import { error } from "console";
import { AuditQuestion } from "../models/AuditQuestion";
import { Audit } from "../models/Audit";
import { AuditDetail } from "../models/AuditDetail";
import { Section } from "../models/Section";
import axios, { AxiosRequestConfig } from "axios";
import { saveAs } from "file-saver";
import { PolicyType } from "../models/PolicyType";
import { AuditQuestionInput } from "../models/AuditQuestionInput";
const API_BASE_URL = process.env.REACT_APP_AUDIT_API_URL;

const getQuestions = async (subsectionId: number): Promise<AuditQuestion[]> => {
  const response = await fetch(
    `${API_BASE_URL}/AuditQuestion/GetQuestions?subsectionId=${subsectionId}`
  );
  const data = await response.json();
  return data;
};

const insertQuestion = async (question: AuditQuestionInput) => {
  const response = await fetch(`${API_BASE_URL}/AuditQuestion/Insert`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(question),
  });

  return response;
};

const updateQuestion = async (question: AuditQuestion) => {
  const response = await fetch(`${API_BASE_URL}/AuditQuestion/Update`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(question),
  });

  return response;
};

const linkQuestion = async (answerId: number, questionId: number) => {
  const obj = { answerId: answerId, questionId: questionId };

  const response = await fetch(`${API_BASE_URL}/AuditQuestion/Link`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(obj),
  });

  return response;
};

const unlinkQuestion = async (answerId: number) => {
  const obj = { answerId: answerId, questionId: null };

  const response = await fetch(`${API_BASE_URL}/AuditQuestion/Unlink`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(obj),
  });

  return response;
};

const deleteQuestion = async (question: AuditQuestion) => {
  const response = await fetch(`${API_BASE_URL}/AuditQuestion/Delete`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(question),
  });

  return response;
};

const updateQuestionPositions = async (
  positionUpdates: Array<{ questionId: number; newPosition: number }>
) => {
  const response = await fetch(
    `${API_BASE_URL}/AuditQuestion/UpdatePositions`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json; charset= utf-8" },
      body: JSON.stringify(positionUpdates),
    }
  );

  return response;
};

const AuditQuestionService = {
  getQuestions,
  insertQuestion,
  updateQuestion,
  linkQuestion,
  unlinkQuestion,
  deleteQuestion,
  updateQuestionPositions,
};

export default AuditQuestionService;
